var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_66328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H67.5V45H0V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H33.75V22.5H0V0Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 11.8969L14.2031 12.7969L15.0844 13.0406L14.9156 12.375L14.4375 11.8969ZM18.8344 12.375L18.6656 13.0406L19.5469 12.7969L19.3125 11.8969L18.8344 12.375ZM14.9156 10.125L14.4375 10.6031L14.6156 11.25L14.9156 10.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6156 11.25L14.4375 11.8969L14.9156 12.375L14.6156 11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4374 10.603L13.7905 11.2499L14.4374 11.8968L14.6155 11.2499L14.4374 10.603ZM15.7499 13.2093L16.228 13.6874L16.8749 13.5093L15.7499 13.2093ZM17.5218 13.6874L18.4218 13.9218L18.6655 13.0405L17.9999 13.2093L17.5218 13.6874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 13.2094L18.6657 13.0406L18.8345 12.375L18.0001 13.2094ZM15.0845 13.0406L15.3282 13.9219L16.2282 13.6875L15.7501 13.2094L15.0845 13.0406ZM16.8751 13.5094L17.522 13.6875L18.0001 13.2094L16.8751 13.5094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2281 13.6876L16.875 14.3345L17.5219 13.6876L16.875 13.5095L16.2281 13.6876ZM15.0844 9.45947L14.2031 9.70322L14.4375 10.6032L14.9156 10.1251L15.0844 9.45947ZM14.9156 12.3751L15.0844 13.0407L15.75 13.2095L14.9156 12.3751ZM19.1344 11.2501L19.3125 10.6032L18.8344 10.1251L19.1344 11.2501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7499 9.29053L15.0843 9.45928L14.9155 10.1249L15.7499 9.29053ZM18.8343 10.1249L18.6655 9.45928L17.9999 9.29053L18.8343 10.1249ZM19.3124 11.8968L19.9593 11.2499L19.3124 10.603L19.1343 11.2499L19.3124 11.8968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8345 10.1251L18.0001 9.29072L16.8751 8.99072L15.7501 9.29072L14.9157 10.1251L14.6157 11.2501L14.9157 12.3751L15.7501 13.2095L16.8751 13.5095L18.0001 13.2095L18.8345 12.3751L19.1345 11.2501L18.8345 10.1251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8345 12.375L19.3126 11.8969L19.1345 11.25L18.8345 12.375ZM19.3126 10.6031L19.547 9.70312L18.6657 9.45938L18.8345 10.125L19.3126 10.6031ZM18.6657 9.45938L18.422 8.57812L17.522 8.8125L18.0001 9.29062L18.6657 9.45938ZM16.2282 8.8125L15.3282 8.57812L15.0845 9.45938L15.7501 9.29062L16.2282 8.8125ZM16.8751 8.99063L16.2282 8.8125L15.7501 9.29062L16.8751 8.99063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5218 8.8124L16.8749 8.16553L16.228 8.8124L16.8749 8.99053L17.5218 8.8124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.29062L17.5218 8.8125L16.8749 8.99063L17.9999 9.29062ZM16.228 13.6875L15.328 13.9219L15.7499 15.4781L16.8749 14.3344L16.228 13.6875ZM15.7499 15.4781L16.8749 19.6875L17.9999 15.4781L16.8749 14.3344L15.7499 15.4781ZM15.0843 13.0406L14.203 12.7969L13.7905 14.3344L15.328 13.9219L15.0843 13.0406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7906 14.3344L12.6656 18.5625L15.75 15.4781L15.3281 13.9219L13.7906 14.3344ZM12.6656 12.375L9.5625 15.4781L13.7906 14.3344L14.2031 12.7969L12.6656 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4374 11.8969L13.7905 11.25L12.6655 12.375L14.203 12.7969L14.4374 11.8969ZM14.4374 10.6031L14.203 9.70312L12.6655 10.125L13.7905 11.25L14.4374 10.6031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6656 10.125L8.4375 11.25L12.6656 12.375L13.7906 11.25L12.6656 10.125ZM21.1031 12.375L19.5469 12.7969L19.9594 14.3344L24.1875 15.4781L21.1031 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6656 13.0406L18.4219 13.9219L19.9594 14.3344L19.5469 12.7969L18.6656 13.0406ZM17.5219 13.6875L16.875 14.3344L18 15.4781L18.4219 13.9219L17.5219 13.6875ZM19.3125 11.8969L19.5469 12.7969L21.1031 12.375L19.9594 11.25L19.3125 11.8969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.478L21.1031 18.5624L19.9594 14.3343L18.4219 13.9218L18 15.478ZM18.6656 9.45928L19.5469 9.70303L19.9594 8.16553L18.4219 8.57803L18.6656 9.45928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1031 10.125L24.1875 7.04062L19.9594 8.16562L19.5469 9.70312L21.1031 10.125ZM19.9594 8.16562L21.1031 3.9375L18 7.04062L18.4219 8.57812L19.9594 8.16562ZM21.1031 12.375L25.3125 11.25L21.1031 10.125L19.9594 11.25L21.1031 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3124 10.6031L19.9593 11.25L21.103 10.125L19.5468 9.70312L19.3124 10.6031ZM15.7499 7.04062L12.6655 3.9375L13.7905 8.16562L15.328 8.57812L15.7499 7.04062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0843 9.45928L15.328 8.57803L13.7905 8.16553L14.203 9.70303L15.0843 9.45928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7906 8.16553L9.5625 7.04053L12.6656 10.1249L14.2031 9.70303L13.7906 8.16553ZM17.5219 8.8124L18.4219 8.57803L18 7.04053L16.875 8.16553L17.5219 8.8124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7.04062L16.875 2.8125L15.75 7.04062L16.875 8.16562L18 7.04062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2281 8.8124L16.875 8.16553L15.75 7.04053L15.3281 8.57803L16.2281 8.8124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8751 16.0407C19.5209 16.0407 21.6657 13.8959 21.6657 11.2501C21.6657 8.60431 19.5209 6.45947 16.8751 6.45947C14.2293 6.45947 12.0845 8.60431 12.0845 11.2501C12.0845 13.8959 14.2293 16.0407 16.8751 16.0407Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8751 15.4782C19.2102 15.4782 21.1032 13.5852 21.1032 11.2501C21.1032 8.91497 19.2102 7.02197 16.8751 7.02197C14.54 7.02197 12.647 8.91497 12.647 11.2501C12.647 13.5852 14.54 15.4782 16.8751 15.4782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_66328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwnFlag);
export default __webpack_public_path__ + "static/media/twn-flag.7df2f0672f2dc89aa474cbbd4a44b2ff.svg";
export { ForwardRef as ReactComponent };